module.exports = __webpack_public_path__ + "img/banner1_i.04d367fb.png";